const t = "{{value, currency}}", e = "Кредит с остаточным платежом", n = "Применить", r = "Сбросить", s = { title: "Выберите программу", empty: { title: "Увы, не найдено ни одной кредитной программы", text: "К сожалению, мы не смогли найти результаты, соответствующие всем выбранным вами критериям. Попробуйте изменить некоторые параметры кредита, чтобы продолжить" }, bank: "Банк", interestRate: "Ставка, %", price: "В месяц" }, c = { downPayment: "Первоначальный взнос, %", residualPayment: "Остаточный платеж, %", creditTerm: "Срок кредита, мес." }, a = {
  currency: t,
  residualPayment: e,
  confirm: n,
  reset: r,
  programs: s,
  sliders: c
};
export {
  n as confirm,
  t as currency,
  a as default,
  s as programs,
  r as reset,
  e as residualPayment,
  c as sliders
};
